<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yzRmuv/tc-custom/9780226172354.jpg?1732274355475" alt="This image is the cover for the book New Day in Babylon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Day in Babylon
      </h1>
      <p class="bookDescription body article font2">
        <p>The most comprehensive account available of the rise and fall of the Black Power Movement and of its dramatic transformation of both African-American and larger American culture. With a gift for storytelling and an ear for street talk, William Van Deburg chronicles a decade of deep change, from the armed struggles of the Black Panther party to the cultural nationalism of artists and writers creating a new aesthetic. Van Deburg contends that although its tactical gains were sometimes short-lived, the Black Power movement did succeed in making a revolution—one in culture and consciousness—that has changed the context of race in America.<br/><br/> "<i>New Day in Babylon</i> is an extremely intelligent synthesis, a densely textured evocation of one of American history's most revolutionary transformations in ethnic group consciousness."—Bob Blauner, <i>New York Times</i><br/><br/> Winner of the Gustavus Myers Center Outstanding Book Award, 1993</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William L. Van Deburg
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37b55b5a